import { makeJourneyImage } from "./journeyImage";
import { APP_NAME, APP_PLAY_URL } from "./appLinks";

// Share the reader's Bible coverage as an image (with text + Play link fallback).
export async function shareJourney({ readFlags, total, overallPct, chaptersRead, streak }) {
  const body = `I've read ${overallPct}% of the Bible (${chaptersRead.toLocaleString()} chapters) on ${APP_NAME}.\n\nTrack your own reading journey free:\n${APP_PLAY_URL}`;

  if (typeof navigator !== "undefined" && navigator.canShare) {
    try {
      const blob = await makeJourneyImage({ readFlags, total, overallPct, chaptersRead, streak });
      if (blob) {
        const file = new File([blob], "my-reading-journey.png", { type: "image/png" });
        if (navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], text: body, title: "My Reading Journey" });
          return "shared";
        }
      }
    } catch (e) {
      if (e && e.name === "AbortError") return "cancelled";
    }
  }

  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({ title: "My Reading Journey", text: body });
      return "shared";
    } catch (e) {
      if (e && e.name === "AbortError") return "cancelled";
    }
  }

  try {
    await navigator.clipboard.writeText(body);
    return "copied";
  } catch {
    return "failed";
  }
}
